import { render, staticRenderFns } from "./AddItemPage.vue?vue&type=template&id=f3cd7c3a&"
import script from "./AddItemPage.vue?vue&type=script&lang=js&"
export * from "./AddItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports